module.exports = __webpack_public_path__ + "static/media/step10.c0a35b6d.png";